import ztComponent from './ztProgressBar.vue'
export default Vue => {
  Vue.component(ztComponent.name, ztComponent)
}
